<div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
      <a class="" rel="studentDetails" href="#" title="Student Details"> </a>
    </div>
  </div>

  <div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header">
      <a class="" rel="studentDetails" href="#" title="Student Details">
        <img
          class="responsive"
          style="width: 100%; height: auto"
          src="assets/images/header-1.png"
        />
      </a>
    </div>

    <section
      id="header"
      class="rounded"
      style="
        margin-top: 1%;
        background-color: white;
        text-align: center;
        text-emphasis-color: inherit;
      "
    >
      <strong>Alok Institute</strong>
      <div class="container">
        <div class="row">
          <div
            class="col-md-12 col-xs-12 col-centered"
            style="align-items: center; text-decoration: underline"
          >
            <strong> PAYMENT DETAILS </strong>
          </div>
        </div>
      </div>
    </section>

    <div class="card" style="margin-top: 1%" >

      <div class="card-body">
        <div *ngIf="!myDIV" >
          <form [formGroup]="form" style="padding:20px 120px 0px 106px;" (ngSubmit)="Submit()">

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Student Name </mat-label>
                <input
                type="text"
                maxlength="40"
                matInput
                placeholder="Student Name"
                formControlName="studentName"
                autocomplete="off"
                required
              />
                <mat-error *ngIf="form.controls['studentName'].hasError('required')">Student Name is required.</mat-error>
                <mat-error *ngIf="form.controls['studentName'].hasError('pattern')">Invalid Student Name</mat-error>
                
              
              </mat-form-field>
            </div>

            

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Email ID </mat-label>
              
              <input
              type="text"
              matInput
              maxlength="50"
              placeholder="Email Id"
              formControlName="emailId"
              autocomplete="off"
              required
            />
                <mat-error *ngIf="form.controls['emailId'].hasError('required')"
                  >Email Id is required.</mat-error
                >
                <mat-error *ngIf="form.controls['emailId'].hasError('pattern')"
                >Invalid Email Id</mat-error
              >
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Mobile No  </mat-label>
                <input type="number" matInput max="10" (keydown)="maxValue($event)" placeholder="Mobile No" formControlName="mobileNo"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('required')"
                  >Mobile No is required.</mat-error>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')"
                >Invalid Mobile No</mat-error>
              </mat-form-field>
            </div>

            

          <div class="form-group" >
          <mat-form-field   style="width:100%">
            <mat-label  >Course Name</mat-label>
            <mat-select formControlName="course" multiple required>
              <mat-option *ngFor="let courses of coursesList" [value]="courses">{{courses}}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls['course'].hasError('required')">Course is required.</mat-error>
          </mat-form-field>
           </div>


           <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Enter Country Name </mat-label>
              <input
              type="text"
              matInput
              placeholder="Country Name"
              formControlName="country"
              autocomplete="off"
              />
              <mat-error *ngIf="form.controls['country'].hasError('required')">Country Name is required.</mat-error>
              <mat-error *ngIf="form.controls['country'].hasError('pattern')">Invalid Country Name</mat-error>
              
            </mat-form-field>
          </div>


          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Enter  Address1</mat-label>
              <input type="text" matInput maxlength="100" placeholder="Address1" formControlName="address1"
              autocomplete="off" />
              <mat-error *ngIf="form.controls['address1'].hasError('required')"> Address1 is required.</mat-error>
            </mat-form-field>
          </div>
                      
              <div class="form-group">
                <mat-form-field style="width:100%">
                  <mat-label>Enter  Address2</mat-label>
                  <input type="text" matInput maxlength="100" placeholder="Address2" formControlName="address2"
                  autocomplete="off" />
                <mat-error *ngIf="form.controls['address2'].hasError('required')"> Address2 is required.</mat-error>
                </mat-form-field>
              </div>


              <div class="form-group">
                <mat-form-field style="width:100%">
                  <mat-label>Enter Pincode </mat-label>
                  <input type="number"  matInput placeholder="Pincode"    max="6"  (keydown)="maxValue($event)"  formControlName="pincode" autocomplete="off" />
                  <mat-error *ngIf="form.controls['pincode'].hasError('required')">Pincode is required.
                    </mat-error>
                    <mat-error *ngIf="form.controls['pincode'].hasError('pattern')">Invalid Pincode
                    </mat-error>

                </mat-form-field>
              </div>
  

              
              <div class="form-group">
                <mat-form-field style="width:100%">
                  <mat-label>Enter Fee Amount</mat-label>
                  <input
                  type="number"
                  matInput
                  max="50"
                  
                  placeholder="Fee Amount"
                  formControlName="feeAmount"
                  autocomplete="off"
                  
                />
                  <mat-error *ngIf="form.controls['feeAmount'].hasError('required')"
                    >Fee Amount is required.</mat-error
                  >
                  <mat-error
                    *ngIf="
                      form.controls['feeAmount'].hasError('pattern')"
                    >Invalid Fee Amount</mat-error
                  >
                </mat-form-field>
              </div>

            <div class="form-group" style="
            display: flex;
            margin-top: 30px;
            justify-content: space-evenly;">
              <button
              #submitButton
              style="width: 129px;"
                class="btn btn-primary"
                

              >
                <span
                  *ngIf="loading"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                SUBMIT
              </button>
            </div>
            <div
              class="errBackButtonDiv"
              style="
                width: 129px !important;
                margin-top: 30px;
                margin-bottom: 20px;
              "
            >

            </div>
          </form>

        </div>
        <div>
          <form
            target="_top"
            #txnForm
            [formGroup]="tranxnForm"
            method="POST"
            action="{{ isgPay_url }}"
          >
            <input
              type="hidden"
              [value]="EncDataField"
              name="EncData"
              formControlName="EncData"
            />
            <input
              type="hidden"
              [value]="MerchantIdField"
              name="MerchantId"
              formControlName="MerchantId"
            />
            <input
              type="hidden"
              [value]="BankIdField"
              name="BankId"
              formControlName="BankId"
            />
            <input
              type="hidden"
              [value]="TerminalIdField"
              name="TerminalId"
              formControlName="TerminalId"
            />
            <input
              type="hidden"
              [value]="VersionField"
              name="Version"
              formControlName="Version"
            />
            <input
              type="hidden"
              [value]="TransactionId"
              name="OrderId"
              formControlName="TransactionId"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
